import { Box } from '@mui/material';

const smDownDisplay = { xs: 'block', sm: 'block', md: 'none' };
export const SmDownBox = props => (
    <Box sx={{ display: smDownDisplay }}>
        {props.children}
    </Box>
);

const mdUpDisplay = { xs: 'none', sm: 'none', md: 'block' };
export const MdUpBox = props => (
    <Box sx={{ display: mdUpDisplay }}>
        {props.children}
    </Box>
);
